import styled, { css } from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';

const MainSwiperMixin = css`
  max-width: 328px;
  max-height: 328px;
  aspect-ratio: 1/1;
  position: unset !important;
  & div.swiper-pagination {
    bottom: 0;
    ${breakpoint('medium')} {
      display: none;
    }
  }
  ${breakpoint('medium')} {
    max-width: 348px;
    max-height: 348px;
  }
  ${breakpoint('large')} {
    max-width: 468px;
    max-height: 468px;
  }
  ${breakpoint('xlarge')} {
    max-width: 660px;
    max-height: 660px;
  }
  ${breakpoint('xxlarge')} {
    max-width: 768px;
    max-height: 768px;
  }
`;

export const StyledSwiper = styled.div`
  position: relative;
  padding-bottom: 3.4rem;
  ${breakpoint('medium')} {
    padding-bottom: unset;
  }

  .mainSwiper {
    ${MainSwiperMixin}
  }
  .mainSwiper-Placeholder {
    ${MainSwiperMixin}
  }
  .image {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .thumbnail-swiper {
    display: none;
    margin-top: 0.8rem;
    max-width: 328px;
    max-height: 328px;
    .swiper-wrapper {
      justify-content: center;
    }
    ${breakpoint('medium')} {
      display: block;
      max-width: 348px;
    }
    ${breakpoint('large')} {
      max-width: 468px;
    }
    ${breakpoint('xlarge')} {
      max-width: 660px;
    }
    ${breakpoint('xxlarge')} {
      max-width: 768px;
    }
  }
  .thumbnail-slide {
    aspect-ratio: 1/1;
    box-sizing: border-box;
    object-fit: contain;
    ${breakpoint('medium')} {
      max-width: 36.5px;
      max-height: 36.5px;
    }
    ${breakpoint('large')} {
      max-width: 51.5px;
      max-height: 51.5px;
    }
    ${breakpoint('xlarge')} {
      max-width: 75.5px;
      max-height: 75.5px;
    }
    ${breakpoint('xxlarge')} {
      max-width: 89px;
      max-height: 89px;
    }
  }
  .thumbnail-image {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    object-fit: contain;
  }
`;
